import { render } from "./StudentGroupsList.vue?vue&type=template&id=080f6e5e&scoped=true"
import script from "./StudentGroupsList.vue?vue&type=script&lang=js"
export * from "./StudentGroupsList.vue?vue&type=script&lang=js"

import "./StudentGroupsList.vue?vue&type=style&index=0&id=080f6e5e&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080f6e5e"]])

export default __exports__